// import React, { useState, useEffect, useRef } from 'react'; 
// import { Link, useNavigate } from 'react-router-dom';
// import { auth } from '../../Components/LoginComp/firebase';
// import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUser, faStar, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
// import './nav.css';

// function NavComp() {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       setIsLoggedIn(!!user);
//     });
//     return () => unsubscribe();
//   }, []);

//   const handleLogout = async () => {
//     try {
//       await auth.signOut();
//       setIsLoggedIn(false);
//       navigate('/');
//     } catch (error) {
//       console.error('Error logging out:', error);
//     }
//   };

//   const toggleDropdown = () => {
//     setShowDropdown(!showDropdown);
//   };

//   const handleDropdownClick = (event) => {
//     if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
//       setShowDropdown(false);
//     }
//   };

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const closeMenu = () => {
//     setIsMenuOpen(false);
//   };

//   return (
//     <nav className="navbar">
//       <div className="navbar-logo">
//         <a href="#">
//           <img src="/logo.jpg" alt="Eye Care Digital Library" className="logo" />
//         </a>
//       </div>
//       <button className="menu-toggle" onClick={toggleMenu}>
//         {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//       </button>
//       <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`} onClick={closeMenu}>
//         <li><a href="/">Home</a></li>
//         <li>
//           <a href="#" className="dropdown-link" onClick={(e) => e.stopPropagation()}>Resources</a>
//           <ul className="dropdown-menu">
//             <li><a href="/researchpaper">Research Papers</a></li>
//             <li><a href="/journalarticle">Journal Article</a></li>
//             <li><a href="/ebooks">E-Books</a></li>
//             <li><a href="/clinicalresource">Clinical Resources</a></li>
//             <li><a href="/thesis">Theses and Dissertations</a></li>
//           </ul>
//         </li>
//         <li><a href= "/advancesearch">Advanced Search</a></li>
//         <li><a href="/aboutus">About Us</a></li>
//         <li><a href="/contactus">Contact Us</a></li>
//       </ul>
//       <div className="navbar-buttons">
//         {isLoggedIn ? (
//           <>
//             <Link to="/uploadresource">
//               <button className="navbar-btn">Upload a Resource</button>
//             </Link>
//             <div className="user-menu-container">
//               <button className="user-icon" onClick={toggleDropdown}>
//                 <FaUserCircle size={24} /> <FaCaretDown size={16} />
//               </button>
//               {showDropdown && (
//                 <ul className="user-dropdown" ref={dropdownRef}>
//                   <li>
//                     <Link to="/userprofile" onClick={handleDropdownClick}>
//                       <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/earnpoint" onClick={handleDropdownClick}>
//                       <FontAwesomeIcon icon={faStar} className="me-2" /> Earned Points
//                     </Link>
//                   </li>
//                   <li>
//                     <button onClick={(e) => { handleLogout(); handleDropdownClick(e); }}>
//                       <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
//                     </button>
//                   </li>
//                 </ul>
//               )}
//             </div>
//           </>
//         ) : (
//           <>
//             <Link to="/login">
//               <button className="navbar-btn">Sign In</button>
//             </Link>
//             <Link to="/signup">
//               <button className="navbar-btn">Sign Up</button>
//             </Link>
//           </>
//         )}
//       </div>
//     </nav>
//   );
// }

// export default NavComp;


import React, { useState, useEffect, useRef } from 'react'; 
import { Link, useNavigate } from 'react-router-dom'; 
import { auth } from '../../Components/LoginComp/firebase'; 
import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 
import './nav.css';

function NavComp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleDropdownClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a href="/">
          <img src="/logo.jpg" alt="Diyatharippu conference" className="logo" />
        </a>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>
      <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`} onClick={closeMenu}>
        <li><a href="/">Home</a></li>
       
        <li>
          <a href="#" className="dropdown-link" onClick={(e) => e.stopPropagation()}>Conference</a>
          <ul className="dropdown-menu">
          <li><a href="/payment">Participate Conference</a></li>
                <li><a href="/conference-program">Conference Program</a></li>
          <li><a href="/stall">Book a Stall</a></li>
            <li><a href="/sponsorAmount">Sponsor</a></li>
      
          </ul>
        </li>

        <li>
          <a href="#" className="dropdown-link" onClick={(e) => e.stopPropagation()}>About Us</a>
          <ul className="dropdown-menu">
          <li><a href="/aboutus">About Us</a></li>
          {/* <li><a href='/governance'>governance</a></li> */}
          <li><a href="/contactus">Contact Us</a></li>
      
          </ul>
        </li>
        <li><a href="/upcomingevent">Events</a></li>

        <li><a href="/abstract">Abstract Submission</a></li> 

           <li><a href="/explore-srilanka">Explore Sri Lanka</a></li> 
        
        {/* Add Sign In and Sign Up buttons inside the toggle menu */}
        {!isLoggedIn && (
          <li className="auth-buttons">
            <Link to="/signin">
              <button className="navbar-btn">Sign In</button>
            </Link>
            <Link to="/signup">
              <button className="navbar-btn">Sign Up</button>
            </Link>
          </li>
        )}
      </ul>
      <div className="navbar-buttons">
        {isLoggedIn ? (
          <>
    
            <div className="user-menu-container">
              <button className="user-icon" onClick={toggleDropdown}>
                <FaUserCircle size={24} /> <FaCaretDown size={16} />
              </button>
              {showDropdown && (
                <ul className="user-dropdown" ref={dropdownRef}>
                  <li>
                    <Link to="/userprofile" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/viewabstraction" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> View My Abstraction 
                    </Link>
                  </li>
                  <li>
                    <button onClick={(e) => { handleLogout(); handleDropdownClick(e); }}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                    </button>
                  </li>
                </ul>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </nav>
  );
}

export default NavComp;
